import { sortByFieldAlphabetically } from '@shared/helpers/utils.helper';
import { map, MonoTypeOperatorFunction } from 'rxjs';

export function sortByFieldAlphabeticallyOperator<T>(field: keyof T, direction: 'asc' | 'desc' = 'asc'): MonoTypeOperatorFunction<T[]> {
    return map((list: T[]) => sortByFieldAlphabetically(list, field, direction));
}
